import React, { useEffect, useState } from 'react';
import { ArenaTrophy, getUserTrophies } from '../../api/group/arena.api';

// Thẻ "Cúp Arena" trên trang cá nhân. Không có cúp thì không hiện gì.
const ArenaTrophiesCard: React.FC<{ userId?: string }> = ({ userId }) => {
  const [trophies, setTrophies] = useState<ArenaTrophy[]>([]);

  useEffect(() => {
    if (!userId) return;
    let cancelled = false;
    getUserTrophies(userId)
      .then((t) => !cancelled && setTrophies(t || []))
      .catch(() => !cancelled && setTrophies([]));
    return () => {
      cancelled = true;
    };
  }, [userId]);

  if (trophies.length === 0) return null;

  return (
    <div className="border-t border-[#DEE0E6] p-3 dark:border-slate-700">
      <h3 className="p-3 text-[22px] font-semibold text-[#19052f] dark:text-white">Cúp Arena</h3>
      <ul className="flex flex-col gap-2 px-3 text-sm text-gray-700 dark:text-white/80">
        {trophies.map((t) => (
          <li key={`${t.challengeId}-${t.teamId}`} className="rounded-lg bg-[#f4f6f9] px-3 py-2 font-medium dark:bg-slate-700/60">
            {t.title}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ArenaTrophiesCard;
